import type AddressType from "@/models/Address.ts";
import Address from "@/models/Address.ts";

export default class RegisteringCompany {
    public reference: string|null = null;
    public firstName: string = '';
    public lastName: string = '';
    public phone: string = '';
    public email: string = '';
    public companyName: string = '';
    public entityName: string = '';
    public website:string  = '';
    public yearsInBusiness: string = '';
    public jobRole: string = '';
    public numberOfEmployees: string = '';
    public companyTurnover: string = '';
    public usesCRM: string = '';
    public buyingLeads: string = '';
    public whoCallsLeads: string = '';
    public buyingLeadsFrom: string = '';
    public address: AddressType;
    public isDuplicated: boolean = false;
    public emailCanLogin:boolean = false;
    public phoneVerified: boolean = false;
    public operatingStates: string[] = [];
    public userReference: string|null = null;

    constructor() {
        this.address = new Address();
    }
}